const { useState, useRef, useEffect } = require("react");

export const AccountSelect = ({
  accounts,
  selectedAccount,
  onChange,
  disabled,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const getPlatformIcon = (platformCode) => {
    const code = platformCode?.toString();

    switch (code) {
      case "IG":
        return "/images/instagram.svg";
      case "TT":
        return "/images/tiktok-logo.svg";
      case "FB":
        return "/images/facebook.svg";
      case "YT":
        return "/images/youtube.svg";
      default:
        return null;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
        className={`w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 flex items-center justify-between bg-white text-left ${
          disabled
            ? "opacity-50 cursor-not-allowed"
            : "cursor-pointer hover:border-gray-400"
        }`}
      >
        {selectedAccount ? (
          <div className="flex items-center gap-2">
            {getPlatformIcon(selectedAccount.social_media_code) && (
              <img
                src={getPlatformIcon(selectedAccount.social_media_code)}
                alt={selectedAccount.social_media_code}
                className="w-6 h-6 object-contain"
                onError={(e) => (e.target.style.display = "none")}
              />
            )}
            <span className="text-gray-900">
              {/* {selectedAccount.social_media_code} */}
              {selectedAccount.handle && ` - ${selectedAccount.handle}`}
            </span>
          </div>
        ) : (
          <span className="text-gray-400">Choose an account...</span>
        )}
        <svg
          className={`w-5 h-5 text-gray-400 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && !disabled && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
          {accounts.length === 0 ? (
            <div className="p-3 text-gray-500 text-center text-sm">
              No accounts available
            </div>
          ) : (
            accounts.map((account) => (
              <div
                key={account.pt_user_id}
                onClick={() => {
                  onChange(account);
                  setIsOpen(false);
                }}
                className={`p-3 flex items-center gap-2 cursor-pointer hover:bg-green-50 transition-colors ${
                  selectedAccount?.pt_user_id === account.pt_user_id
                    ? "bg-green-100"
                    : ""
                }`}
              >
                {getPlatformIcon(account.social_media_code) && (
                  <img
                    src={getPlatformIcon(account.social_media_code)}
                    alt={account.social_media_code}
                    className="w-6 h-6 object-contain"
                    onError={(e) => (e.target.style.display = "none")}
                  />
                )}
                <span className="text-gray-900">
                  {/* {account.social_media_code} */}
                  {account?.handle}
                </span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};
